import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from "react-i18next";

import { DevicesColumn } from './DevicesColumn';

import { appPermissions } from '../_constants/permissions.constants';
import { filterModeParameters } from '../_constants';
import { CustomSearchBar, MainPageWithButtons } from '../_components';
import { devicesActions } from '../_actions';
import { Selectors } from '../_reducers/app.reducer';
import { DeviceFilterSelector } from './DeviceFilterSelector';
import { DeviceCategoriesFilter } from './DeviceCategoriesFilter';

export function DevicesMainPage({ isEmbedded = false }) {

    //LIBRARIES
    const { t } = useTranslation();
    const dispatch = useDispatch();

    //GLOBAL STATE
    const filterMode    = useSelector(Selectors.getDeviceFilterFilterMode);
    const categories    = useSelector(Selectors.getDeviceFilterCategories);
    
    const markedDevice  = useSelector(Selectors.getMarkedDevice);
    const devices       = useSelector(Selectors.getSelectedLocationDevices);
    const rooms         = useSelector(Selectors.getRooms);
    const locationUid   = useSelector(Selectors.getSelectedLocationUid);

    const permission    = useSelector(Selectors.getPermissionSelectedLocation);


    //LOCAL STATE
    const [searchText, setSearchText] = useState('');
    const canViewSettings = appPermissions.canUserViewDeviceSettings(
        permission,
    );

    //INITIALIZATION
    useEffect(() => {
        dispatch(devicesActions.initializeDevices(
            markedDevice,
            filterMode,
            devices,
            rooms,
        ));
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, locationUid, rooms]);

    useEffect(() => {
        dispatch(devicesActions.showDevicesOfSelectedCategories(
            devices,
            categories,
            filterMode,
        ));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, categories]);

    const activeCategories = useMemo(() => categories.filter(category => category.active), [categories])

    //VIEW
    return (
        <MainPageWithButtons
            size={'UNLIMITED'}
            pageTitle={t("devices.devices")}
            content={devicesContent()}
            buttons={[<DeviceFilterSelector />]}
            isFlat={isEmbedded}
        />
    );


    function devicesContent() {
        return (
            <div
                className="d-flex flex-column h-100 pt-3"
                style={{ gap: 12 }}
            >
                <div
                    className="d-flex flex-wrap align-items-center"
                    style={{ gap: 12 }}
                >
                    <div style={{ minWidth: 240 }}>
                        <CustomSearchBar
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            placeholder={t('global_search_placeholder')}
                            className="w-100"
                        />
                    </div>
                    <DeviceCategoriesFilter />
                </div>
                <div style={{ flex: '1 1 auto', minHeight: 0 }}>
                    <DevicesColumn
                        filterModeParameter={getFilterModeParam(filterMode)}
                        activeCategories={activeCategories}
                        devices={devices}
                        canViewSettings={canViewSettings}
                        searchText={searchText}
                    />
                </div>
            </div>
        );
    }

    function getFilterModeParam(deviceFilterMode) {
        return filterModeParameters[deviceFilterMode];
    }
}